export default __webpack_public_path__ + "static/3.7d2a992c20bedc38b02fdef4c2a61ab4.png";